import { QUERY_DELETE_MAIL_MAPPER, QUERY_GET_MAIL_MAPPERS, QUERY_POST_CREATE_MAIL_MAPPER, QUERY_PUT_UPDATE_MAIL_MAPPER } from '../../fetch/constantQueries';
import { baseThunk } from '../../fetch/basicThunk';

export const getMailMappersPag = baseThunk(`mailMapper/getMailMappersPag`, QUERY_GET_MAIL_MAPPERS, "GET");

export const createMailMapper = baseThunk("mailMapper/create", QUERY_POST_CREATE_MAIL_MAPPER, "POST");

export const updateMailMapper = baseThunk("mailMapper/update", QUERY_PUT_UPDATE_MAIL_MAPPER, "PUT");

export const deleteMailMapper = baseThunk("mailMapper/delete", QUERY_DELETE_MAIL_MAPPER, "DELETE")